export default __webpack_public_path__ + "static/media/arrow-down-blue.a1b239ca.svg";